<template>
    <section class="bg-[#f9f9f9] py-20 px-4">
      <div class="max-w-6xl mx-auto text-center mb-16">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Ei, você precisa saber disso...
        </h2>
        <p class="text-sm text-gray-500">
          veja algumas vantagens que você encontra somente aqui
        </p>
      </div>
  
      <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(item, index) in vantagens"
          :key="index"
          class="bg-white rounded-2xl shadow p-6 text-center"
        >
          <div class="flex justify-center mb-4">
            <img :src="item.icone" :alt="item.titulo" class="w-40 h-40" />
          </div>
          <h3 class="font-bold text-lg mb-2">{{ item.titulo }}</h3>
          <p class="text-sm text-gray-600">{{ item.descricao }}</p>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const vantagens = [

 
    {
      titulo: 'Docker',
      descricao:
        'Implemente e gerencie containers Docker facilmente, simplificando o deploy e a automação.',
      icone: '/icones-vantagens/docker.svg'
    },
    {
      titulo: 'App Store',
      descricao:
        'Simplifique a gestão de apps em Docker: varios apps disponíveis, deploy ágil, gerenciamento fácil.',
      icone: '/icones-vantagens/apps.svg'
    },
    {
      titulo: 'Domínios',
      descricao:
        'Gerencie containers Docker e múltiplos domínios ilimitados no ICP com SSL grátis.',
      icone: '/icones-vantagens/www.svg'
    },
    {
      titulo: 'SSL',
      descricao:
        'Tenha SSL gratuito com facilidade em todoso seus domínios e subdomínios.',
      icone: '/icones-vantagens/ssl.svg'
    },
    {
      titulo: 'Recursos',
      descricao:
        'Monitore recursos em tempo real: CPU, memória, disco e rede, tudo em uma interface simples e intuitiva!o.',
      icone: '/icones-vantagens/recurso.svg'
    },
    {
      titulo: 'Suporte especializado',
      descricao:
        'Suporte especializado com programadores que entendem a sua solicitação.',
      icone: '/icones-vantagens/suporte.svg'
    },
    {
      titulo: 'Armazenamento',
      descricao:
        'Infraestrutura moderna com discos SSD NVMe, em RAID 10, dando segurança e garantia no armazenamento de seus dados.',
      icone: '/icones-vantagens/ssd.svg'
    },
    {
      titulo: 'Desempenho',
      descricao:
        'Usamos os novos processadores AMD EPYC™ criados para lidar com cargas de trabalho intensas. Muito mais desempenho para o seu negócio.',
      icone: '/icones-vantagens/desempenho.svg'
    },
    {
      titulo: 'Proteção DDoS',
      descricao:
        'Nossa infraestrutura é protegida no nível da rede. Você pode ter certeza de que suas instâncias serão resilientes aos ataques mais populares.',
      icone: '/icones-vantagens/ddos.svg'
    }
  ]
  </script>
  